import { ChangeDetectionStrategy, Component } from "@angular/core";
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";

/**
 * Confirmation dialog shown before navigating back to the detection configuration,
 * warning the user that previous results will be overwritten.
 * Returns true when the user confirms, false/undefined on cancel.
 */
@Component({
  selector: "lib-confirm-back-to-config-dialog",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose, MatButton],
  template: `
    <h2 mat-dialog-title>Return to detection configuration?</h2>
    <mat-dialog-content>
      <p class="mat-font-body-sm">
        The previous result set will be overwritten and replaced by the new results.
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Cancel</button>
      <button mat-flat-button color="primary" [mat-dialog-close]="true">Confirm</button>
    </mat-dialog-actions>
  `,
})
export class ConfirmBackToConfigDialogComponent {}